<template>
  <layout name="LayoutRegister">
    <router-view />
  </layout>
</template>

<script>
import Layout from '@/layouts/Layout'
import { SvgLogo } from '@leapsight/styleguide'
import store from '@/store'
export default {
  name: 'RegisterView',
  components: {
    Layout,
    SvgLogo
  },
  props: {},
  data() {
    return {}
  },
  methods: {},
  computed: {},
  watch: {},
  beforeRouteEnter(to, from, next) {
    // Al acceder a la pantalla de registro verifico si se encuentra logeado, de ser asi revoco el acceso
    store.dispatch('auth/checkTokenIsActive').then(function(response) {
      if (response && store.getters['auth/isLoggedIn']) {
        //Revoco el token
        store.dispatch('auth/logout').then(() => {
          //Elimino información restante
          localStorage.clear()
          next()
        })
      } else {
        //Si no se encuentra logeado eliminamos información residual del localStorage
        localStorage.clear()
        next()
      }
    })
  }
}
</script>
